/**
 * @fileoverview Ponto de entrada da aplicação React VikanaWeb.
 * Configura o root da aplicação e renderiza o componente App em modo estrito
 * para detecção de problemas durante o desenvolvimento.
 *
 * @module Main
 * @author VikanaWeb Team
 * @since 1.0.0
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import './utils/hybridInit.js';

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
